var _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedometer3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    stroke: "#969595",
    strokeWidth: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.6111,
    y1: 32.549,
    x2: 16.5489,
    y2: 29.049,
    stroke: "#4A4A4A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 47.5,
    y1: 21.5,
    x2: 47.5,
    y2: 11.5,
    stroke: "#4A4A4A",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 61.451,
    y1: 20.6111,
    x2: 64.951,
    y2: 14.5489,
    stroke: "#4A4A4A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 74.549,
    y1: 28.951,
    x2: 80.6112,
    y2: 25.451,
    stroke: "#4A4A4A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 78.5,
    y1: 44.5,
    x2: 88.5,
    y2: 44.5,
    stroke: "#4A4A4A",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 47.5,
    x2: 22.5,
    y2: 47.5,
    stroke: "#4A4A4A",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 29.951,
    y1: 23.1111,
    x2: 26.451,
    y2: 17.0489,
    stroke: "#4A4A4A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.4951,
    cy: 49.1992,
    r: 8,
    fill: "#F83600",
    stroke: "#F83600",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4402 27.5163L55.5741 49.9745L51.0578 42.1521L85.4402 27.5163Z",
    fill: "#F83600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer3);
export default __webpack_public_path__ + "static/media/speedometer3.96e2ba40c1ff359659dbb17f63bfde66.svg";
export { ForwardRef as ReactComponent };